import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import Alert from 'react-bootstrap/Alert'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Card from 'react-bootstrap/Card';
import CardDeck from 'react-bootstrap/CardDeck';

import qs from 'qs';
import {CollapsibleComponent, CollapsibleHead, CollapsibleContent} from 'react-collapsible-component';

import CurrentRewards from './CurrentRewards';
import ApiUtils from '../util/ApiUtils';
import "./Rewards.css";
import Utilities from "../util/Utilities";
import SPUtilities from "../util/SPUtilities";
import SPCalc from "../util/SPCalc";
import FilterRewards from "./FilterRewards";
import Views from "./Views";
import AddressFilterUtils from "../util/AddressFilterUtils";

class Rewards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rewards: [],
      rewardsHistory: [],
      rewardsHistorySummary: [],
      rewardsHistorySummaryAnnual: [],
      filterState: {
        address: [],
        alias: "",
      },
      coinStats: {},
      showView: true,
      showHistory: true,
      width: window.innerWidth,
      size: 10,
    }
    this.updateDimensions = this.updateDimensions.bind(this);
    this.filterData = this.filterData.bind(this);
    this.saveAlias = this.saveAlias.bind(this);
    this.addView = this.addView.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);

    let filterState = AddressFilterUtils.getFilterState(this);
    //console.log("componentDidMount - filterState is: ", filterState);
    this.setState({filterState: filterState});

    if (filterState.address.length != 0 || (filterState.alias != null && filterState.alias != "")) {
      this.loadData(filterState);
    }

    this.setState({isLoading: false});
  }

  async filterData() {
    await this.loadData(this.state.filterState);
  }

  async saveAlias() {
    await AddressFilterUtils.saveAlias(this);
  }

  onAliasChange = (value) => {
    AddressFilterUtils.onAliasChange(this, value);
  }

  onAddressSelect = (value) => {
    // alert((value != null));
    // console.log("value is: " + value);
    // console.log("value.toString() is: " + value.toString());
    // console.log("value.toString().toLowerCase() is: " + value.toString().toLowerCase());
    // console.log("onaddressChange: value is: ", value);
    AddressFilterUtils.updateFilterState("address", Utilities.toLowerCaseArray(value), this);
  }

  render() {
    if (this.state.isLoading) {
      return <div>Loading</div>;
    }

    let totalStake = SPCalc.getTotal(this.state.rewards, "stake", true);
    let totalRewards = SPCalc.getTotal(this.state.rewards, "reward", true);

    //console.log("this.state.filterState : ", this.state.filterState);
    return (
      <div>
        <p/>
        <h4 style={{align: "center"}}><span><strong>Rewards</strong></span></h4>
        (Click on an address to view more details of the address)

        <FilterRewards filterData={this.filterData} filterState={this.state.filterState}
          onAddressSelect ={this.onAddressSelect} saveAlias ={this.saveAlias}
          onAliasChange ={this.onAliasChange} />
        {this.addView()}
        {this.renderRewardHeader(totalStake, totalRewards)}
        <CurrentRewards rewards={this.state.rewards} />
        <p>&nbsp;</p><hr/>
        {this.state.showHistory && this.renderRewardsHistory()}
        <p>&nbsp;</p><hr/>
        {this.state.showHistory && this.renderRewardsHistorySummary()}
        <p>&nbsp;</p><hr/>
        {this.state.showHistory && this.renderRewardsHistorySummaryAnnual()}
        {this.getNote()}
      </div>
    );
  }

  // {this.renderRewards(totalStake, totalRewards)}

  renderRewardHeader(totalStake, totalRewards) {
    if (!this.state.coinStats) {
      return;
    }

    //console.log("addresses are: ", this.state.filterState.address);
    let addresses = this.state.filterState.address.join(", ");
    //console.log("alias is: ", this.state.filterState.alias);
    let totalStakeInt = parseFloat(totalStake);
    let totalRewardsInt = parseFloat(totalRewards);

    let totalAion = totalStakeInt + totalRewardsInt;
    let totalAionStr = totalAion.toLocaleString();
    let btcPrice = this.state.coinStats.btcPrice;
    let usdPrice = this.state.coinStats.usdPrice;

    let usdValueStaked = "N/A";
    let btcValueStaked = "N/A";
    let usdValueRewards = "N/A";
    let btcValueRewards = "N/A";
    let usdValueTotal = "N/A";
    let btcValueTotal = "N/A";

    if (!isNaN(totalAion) && !isNaN(usdPrice) && !isNaN(btcPrice) ) {
      usdValueTotal = SPCalc.multiplyAndFormat(totalAion, usdPrice, 2);
      btcValueTotal = SPCalc.multiplyAndFormat(totalAion, btcPrice, 8);

      usdValueRewards = SPCalc.multiplyAndFormat(totalRewardsInt, usdPrice, 2);
      btcValueRewards = SPCalc.multiplyAndFormat(totalRewardsInt, btcPrice, 8);

      usdValueStaked = SPCalc.multiplyAndFormat(totalStakeInt, usdPrice, 2);
      btcValueStaked = SPCalc.multiplyAndFormat(totalStakeInt, btcPrice, 8);
    }

    return (
      <div>
        <p/>
        <CardDeck>
          <Card border="danger" bg="dark" text="white" style={{ width: '18rem' }}>
            <Card.Header>Total Stake</Card.Header>
            <Card.Body>
              <Card.Title>AION {SPCalc.formatCoinCount(totalStake)}</Card.Title>
              <Card.Text>USD ${usdValueStaked} (${usdPrice} per AION)</Card.Text>
              <Card.Text>BTC {String.fromCharCode(8383)}{btcValueStaked} ({String.fromCharCode(8383)}{btcPrice} per AION)</Card.Text>
            </Card.Body>
          </Card>

          <Card border="danger" bg="dark" text="white" style={{ width: '18rem' }}>
            <Card.Header>Total Reward</Card.Header>
            <Card.Body>
              <Card.Title>AION {SPCalc.formatCoinCount(totalRewards)}</Card.Title>
              <Card.Text>USD ${usdValueRewards}</Card.Text>
              <Card.Text>BTC {String.fromCharCode(8383)}{btcValueRewards}</Card.Text>
            </Card.Body>
          </Card>

          <Card border="danger" bg="dark" text="white" style={{ width: '18rem' }}>
            <Card.Header>Total Aion (Staked + Rewards)</Card.Header>
            <Card.Body>
              <Card.Title>AION {totalAionStr}</Card.Title>
              <Card.Text>USD ${usdValueTotal}</Card.Text>
              <Card.Text>BTC {String.fromCharCode(8383)}{btcValueTotal}</Card.Text>
            </Card.Body>
          </Card>
        </CardDeck>

        <p/>
        <Alert variant="info">
          <Alert.Heading>Stake/Reward Summary</Alert.Heading>
          <ul>
            <li>Addresses - <span><strong>{SPUtilities.delegateLinks(addresses)}</strong></span></li>
            <li>Alias - <span><strong>{this.state.filterState.alias}</strong></span></li>
          </ul>
        </Alert>
        <p/>

      </div>);
  }

  renderRewards(totalStake, totalRewards) {
    // console.log("pool data is:", this.state);
    var columns;
    if (window.innerWidth < 1000) {
      columns = [
        {text: "Address",dataField: "address", formatter: SPUtilities.addressShortFormatter, sort: true, headerStyle: Utilities.width(30)},
        {text: "Pool Name", dataField: "poolName", formatter: SPUtilities.poolNameFormatter, sort: true,  headerStyle: Utilities.width(25)},
        {text: "Stake",dataField: "stake", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(20)},
        {text: "Rewards",dataField: "reward", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(25)},
      ];
    } else {
      columns = [
        {text: "Address",dataField: "address", formatter: SPUtilities.addressShortFormatter, sort: true, headerStyle: Utilities.width(15)},
        {text: "Pool Name", dataField: "poolName", formatter: SPUtilities.poolNameFormatter, sort: true,  headerStyle: Utilities.width(20)},
        {text: "Pool Total Stake", dataField: "totalStake", formatter: SPUtilities.coinCountCellFormatter, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
        {text: "Stake in Pool",dataField: "stake", formatter: SPUtilities.coinCountCellFormatter, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10)},
        {text: "% Stake (portfolio)",dataField: "stake", formatter: SPCalc.calcWeight, formatExtraData: totalStake, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
        {text: "Rewards in Pool",dataField: "reward", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10)},
        {text: "% Rewards (portfolio)",dataField: "reward", formatter: SPCalc.calcWeight, formatExtraData: totalRewards, sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
      ];
    }

    return (<div>
      <BootstrapTable keyField='poolName' data={ this.state.rewards }
        columns={ columns } striped expandableRow={ () => { return true; } }
        hover condensed noDataIndication="No results"/>
      </div>);
  }

  renderRewardsHistory() {
    let totalRewards = SPCalc.getTotal(this.state.rewardsHistory, "amount", true);

    let totalRewardsInt = parseFloat(totalRewards);
    let btcPrice = this.state.coinStats.btcPrice;
    let usdPrice = this.state.coinStats.usdPrice;
    let usdValueRewards = SPCalc.multiplyAndFormat(totalRewardsInt, usdPrice, 2);
    let btcValueRewards = SPCalc.multiplyAndFormat(totalRewardsInt, btcPrice, 8);

    return (<div>
      <p/>
      <Alert variant="info">
        <Alert.Heading>Withdrawal History</Alert.Heading>
        <p/>Total Rewards Withdrawn - <span><strong>{SPCalc.formatCoinCount(totalRewards)}
          </strong></span> &nbsp;(BTC - <span><strong>{btcValueRewards}</strong></span>, USD -
          &nbsp;<span><strong>${usdValueRewards}</strong></span>)
        <br/>Total does not include outstanding rewards (yet to be withdrawn).
      </Alert>
      <p/>
      <BootstrapTable keyField='blockTimestamp' data={ this.state.rewardsHistory }
        columns={ this.getRewardsHistoryColumns("Withdrawal Time") } striped expandableRow={ () => { return true; } }
        hover condensed noDataIndication="No results"/>
      <p/>
      </div>);
  }

  getRewardsHistoryColumns(timeframe) {
    var columns;
    if (window.innerWidth < 600) {
      columns = [
        {text: "Address", dataField: "address", formatter: SPUtilities.addressShortFormatter, sort: true, headerStyle: Utilities.width(20)},
        {text: "Pool Name", dataField: "poolName", formatter: SPUtilities.poolNameFormatter, sort: true,  headerStyle: Utilities.width(25)},
        {text: "Rewards", dataField: "amount", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(25)},
        {text: timeframe, dataField: "withdrawalTime", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(30)},
      ];
    } else {
      columns = [
        {text: "Address", dataField: "address", formatter: SPUtilities.addressShortFormatter, sort: true, headerStyle: Utilities.width(30)},
        {text: "Pool Name", dataField: "poolName", formatter: SPUtilities.poolNameFormatter, sort: true,  headerStyle: Utilities.width(20)},
        {text: "Rewards", dataField: "amount", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(25)},
        {text: timeframe, dataField: "withdrawalTime", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(25)},
      ];
    }

    return columns;
  }

  renderRewardsHistorySummary() {
    let totalRewards = SPCalc.getTotal(this.state.rewardsHistorySummary, "amount", true);

    let totalRewardsInt = parseFloat(totalRewards);
    let btcPrice = this.state.coinStats.btcPrice;
    let usdPrice = this.state.coinStats.usdPrice;
    let usdValueRewards = SPCalc.multiplyAndFormat(totalRewardsInt, usdPrice, 2);
    let btcValueRewards = SPCalc.multiplyAndFormat(totalRewardsInt, btcPrice, 8);

    return (<div>
      <p/>
      <Alert variant="info">
        <Alert.Heading>Withdrawal History - Monthly Summary</Alert.Heading>
        <p/>Total Rewards Withdrawn - <span><strong>{SPCalc.formatCoinCount(totalRewards)}
          </strong></span> &nbsp;(BTC - <span><strong>{btcValueRewards}</strong></span>, USD -
          &nbsp;<span><strong>${usdValueRewards}</strong></span>)
        <br/>Total does not include outstanding rewards (yet to be withdrawn).
      </Alert>
      <p/>
      <BootstrapTable keyField='blockTimestamp' data={ this.state.rewardsHistorySummary }
        columns={ this.getRewardsHistoryColumns("Month") } striped expandableRow={ () => { return true; } }
        hover condensed noDataIndication="No results"/>
      <p/>
      </div>);
  }

  renderRewardsHistorySummaryAnnual() {
    let totalRewards = SPCalc.getTotal(this.state.rewardsHistorySummaryAnnual, "amount", true);

    let totalRewardsInt = parseFloat(totalRewards);
    let btcPrice = this.state.coinStats.btcPrice;
    let usdPrice = this.state.coinStats.usdPrice;
    let usdValueRewards = SPCalc.multiplyAndFormat(totalRewardsInt, usdPrice, 2);
    let btcValueRewards = SPCalc.multiplyAndFormat(totalRewardsInt, btcPrice, 8);

    return (<div>
      <p/>
      <Alert variant="info">
        <Alert.Heading>Withdrawal History - Annual Summary</Alert.Heading>
        <p/>Total Rewards Withdrawn - <span><strong>{SPCalc.formatCoinCount(totalRewards)}
          </strong></span> &nbsp;(BTC - <span><strong>{btcValueRewards}</strong></span>, USD -
          &nbsp;<span><strong>${usdValueRewards}</strong></span>)
        <br/>Total does not include outstanding rewards (yet to be withdrawn).
      </Alert>
      <p/>
      <BootstrapTable keyField='blockTimestamp' data={ this.state.rewardsHistorySummaryAnnual }
        columns={ this.getRewardsHistoryColumns("Year") } striped expandableRow={ () => { return true; } }
        hover condensed noDataIndication="No results"/>
      <p/>
      </div>);
  }

  getNote() {
    return (<div>
      <hr/>
      <CollapsibleComponent name="note">
        <CollapsibleHead isExpanded={false}><font color="black"><b>Note</b> - click here for details</font>
        </CollapsibleHead>
        <CollapsibleContent isExpanded={false}>
          <ul>
            <li>This feature is still being tested and may have some inaccuracies. Please report issues if any.</li>
            <li>% rewards is useful for comparison only if:</li>
            <ul>
              <li>staking was done at the same time or </li>
              <li>or rewards were last withdrawn at the same time from all pools</li>
            </ul>
          </ul>
        </CollapsibleContent>
      </CollapsibleComponent>
    </div>);
  }

  async loadData(filterState) {
    this.setState({showView: false});
    // console.log("loadData - in load data: ", filterState);

    let finalUrl = AddressFilterUtils.getBackendUrl(this, filterState, "listData?type=listRewards");
    //console.log("loadData - Rewards: in loadData: finalUrl - " + finalUrl);
    const data = await ApiUtils.get(finalUrl);
    // console.log("loadData - rewards list response is:");
    // console.log(data);
    const coinStats = await ApiUtils.get("getCoinStats?symbol=AION");
    if (coinStats) {
      this.setState({coinStats: coinStats});
    }

    if (data) {
      // console.log("loadData - in data");
      let resultsFound = false;
      if (this.state.showHistory) {
        this.setState({rewards: data["data"], rewardsHistory: data["history"],
          rewardsHistorySummary: data["historySummary"],
          rewardsHistorySummaryAnnual: data["historySummaryAnnual"],
          isLoading: false});
        resultsFound = data["data"].length > 0;
      } else {
        this.setState({rewards: data, isLoading: false});
        resultsFound = data.length > 0;
      }
    }

    // console.log("calling saveLastCriteria with filterState: ", filterState)
    AddressFilterUtils.saveLastCriteria(filterState);
    if (filterState.alias != undefined && filterState.alias != "") {
      AddressFilterUtils.saveLocally(filterState.alias);
    }

    this.timeout = setTimeout(() => {
        this.setState({showView: true});
      }, 300);
  }

  addView() {
    if (this.state.showView) {
      return <Views viewType="rewards"/>
    }
    return "";
  }
}

export default Rewards;



// WEBPACK FOOTER //
// ./src/address/Rewards.js